import { Component, Injectable, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MessageService } from 'primeng/api';
import { PatientService } from '../../../services/patient.service';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { CdkColumnDef } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { SafeResourceUrl } from '@angular/platform-browser';

import { provideAnimations } from '@angular/platform-browser/animations';
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};
@Component({
  selector: 'pharmacy-billing',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatTableModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ToastModule,
    MatDialogModule
  ],
  templateUrl: './pharmacy-billing.component.html',
  styleUrls: ['./pharmacy-billing.component.scss'],
  providers: [MessageService, CdkColumnDef,

    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }]
})

export class PharmacyBillingComponent {

  quotationPdfUrl!: SafeResourceUrl;
  patientName = "";
  pramPatientId: any;
  medicineQuotationArr: any[] = [];
  lastVisitMed: any[] = [];
  iframeHeight: number = 600;
  @ViewChild("quotationPreviewModal") quotationPreviewModal!: TemplateRef<any>;
  pdfSrc: string | ArrayBuffer | null = null;
  showPdfModal = false;

  constructor(
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private patientService: PatientService,
    private route: ActivatedRoute
  ) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      this.pramPatientId = this.pramPatientId ? params.patientId : params.patientId
    })
    this.getAppointmentsByPatientId();
    this.medicineQuotationArr.forEach((med: any) => {
      med.quantity = this.calculateQuantity(med);  // reference only
      med.packaging = med.quantity;                 // default same as quantity
      console.log("medicineQuotationArr", this.medicineQuotationArr);

    });
    const patientDataString = localStorage.getItem('patientMoreData');
    let patientDataFromLocal: any;

    if (patientDataString) {
      patientDataFromLocal = JSON.parse(patientDataString);
    } else {
      // Handle the case when there is no data found for the given key
      patientDataFromLocal = {}; // or set to null, or any default value
      console.warn('No data found for key: patientMoreData');
    }

    this.patientName = patientDataFromLocal.firstName + " " + patientDataFromLocal.lastName;
    console.log("patientName", this.patientName);

    this.updateIframeHeight();
    window.addEventListener('resize', this.updateIframeHeight.bind(this));
  }

  updateIframeHeight() {
    const modalPadding = 100; // header + footer approx
    this.iframeHeight = Math.max(window.innerHeight - modalPadding, 400); // min 400px
  }

  numberToWords(num: number): string {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
      'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

    function convert_hundreds(n: number): string {
      let str = '';
      if (n > 99) {
        str += ones[Math.floor(n / 100)] + ' Hundred ';
        n %= 100;
      }
      if (n >= 10 && n < 20) str += teens[n - 10] + ' ';
      else if (n >= 20) {
        str += tens[Math.floor(n / 10)] + ' ';
        if (n % 10 > 0) str += ones[n % 10] + ' ';
      } else if (n > 0) str += ones[n] + ' ';
      return str.trim();
    }

    function convert_number(n: number): string {
      if (n === 0) return '';

      let result = '';

      if (n >= 10000000) {
        result += convert_number(Math.floor(n / 10000000)) + ' Crore ';
        n %= 10000000;
      }
      if (n >= 100000) {
        result += convert_number(Math.floor(n / 100000)) + ' Lakh ';
        n %= 100000;
      }
      if (n >= 1000) {
        result += convert_number(Math.floor(n / 1000)) + ' Thousand ';
        n %= 1000;
      }
      if (n > 0) {
        result += convert_hundreds(n);
      }

      return result.trim();
    }

    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);

    let words = '';
    if (rupees > 0) words += convert_number(rupees) + ' Rupees';
    if (paise > 0) words += (words ? ' and ' : '') + convert_hundreds(paise) + ' Paise';

    return words || 'Zero Rupees';
  }


  // 🔹 Single generator: it only RETURNS the doc

  // 🔹 Single generator: it only RETURNS the doc
  private createQuotationPdf(): jsPDF | null {
    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text('Pharmacy Billing', 14, 20);

    doc.setFontSize(11);
    doc.text(`Patient Name: ${this.patientName || '-'}`, 14, 28);

    // Only include medicines with MRP filled
    const validMedicines = this.medicineQuotationArr.filter(
      (row: any) => row.packaging && row.mrp
    );

    if (validMedicines.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Data',
        detail: 'Please enter MRP for all medicines before previewing the quotation.',
      });
      return null;
    }

    const formatDate = (date: any) => {
      if (!date) return '-';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '-';
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')
        }/${d.getFullYear()}`;
    };

    const formatPrice = (val: any, prefix = 'Rs.') =>
      val != null ? `${prefix}${parseFloat(val).toFixed(2)}` : `${prefix}0.00`;

    // Table
    autoTable(doc, {
      startY: 35,
      head: [[
        'Sr No',
        'Medicines',
        'Quantity',
        'Batch No  Expiry Date',
        'MRP',
        'SGST (2.5%)',
        'CGST (2.5%)',
        'Total Amount'
      ]],
      body: validMedicines.map((row: any, index: number) => [
        index + 1,
        row.medicines || row.medicineName || row.Drug?.product_name || '-',
        row.packaging || '-',
        (row.batchNo || '-') + '\n' + (row.expiryDate ? formatDate(row.expiryDate) : '-'),
        formatPrice(row.mrp),
        formatPrice(row.sgst),
        formatPrice(row.cgst),
        formatPrice(row.totalAmount)
      ]),
      styles: {
        overflow: 'linebreak',
        cellWidth: 'wrap',
        halign: 'left',   // ✅ align all cells to left
        valign: 'middle'
      },
      headStyles: {
        halign: 'left',   // ✅ align header to left
        valign: 'middle',
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 40 },
        2: { cellWidth: 20 },
        3: { cellWidth: 30 },
        4: { cellWidth: 20 },
        5: { cellWidth: 20 },
        6: { cellWidth: 20 },
        7: { cellWidth: 25 },
      },
      tableWidth: 'auto',
    });


    // Totals
    // const finalY = (doc as any).lastAutoTable.finalY + 10;
    // const totalMedicines = validMedicines.length;
    // const totalAmount = validMedicines.reduce(
    //   (sum: number, row: any) => sum + (parseFloat(row.totalAmount) || 0),
    //   0
    // );

    // // Right-align total amount for better presentation
    // doc.text(`Total Medicines: ${totalMedicines}`, 14, finalY);
    // doc.text(`Total Amount: Rs.${totalAmount.toFixed(2)}`, 150, finalY);
    const finalY = (doc as any).lastAutoTable.finalY + 10;
    const totalMedicines = validMedicines.length;
    const totalAmount = validMedicines.reduce(
      (sum: number, row: any) => sum + (parseFloat(row.totalAmount) || 0),
      0
    );

    doc.setFontSize(11);
    doc.text(`Total Medicines: ${totalMedicines}`, 14, finalY);

    // Total amount in numbers + words
    const totalAmountText = `Total Amount: Rs.${totalAmount.toFixed(2)} (${this.numberToWords(totalAmount)})`;
    doc.text(totalAmountText, 14, finalY + 8);

    return doc;
  }


  get totalQuotationAmount(): number {
    return this.medicineQuotationArr.reduce((acc, curr) => acc + (curr.totalAmount || 0), 0);
  }



  previewInNewTab() {
    const doc = this.createQuotationPdf();
    if (!doc) return;
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  }


  previewQuotation() {
    // Calculate total amount
    const totalAmount = this.totalQuotationAmount;

    // Prepare patient data with today's date
    const todayStr = new Date().toISOString().split("T")[0]; // e.g. "2025-09-17"
    const patientData = {
      PatientId: this.pramPatientId,
      MedicineAmount: Number(totalAmount.toFixed(2)),
      date: todayStr
    };

    // ✅ Store only one record (overwrite old data)
    localStorage.setItem('QuotationSummary', JSON.stringify([patientData]));

    // Continue with PDF
    const doc = this.createQuotationPdf();
    if (!doc) return;

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    this.quotationPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);

    this.dialog.open(this.quotationPreviewModal, {
      width: '80%',
      height: '80%'
    });
  }



  // previewQuotation() {
  //   const hasMissingMrp = this.medicineQuotationArr.some(
  //     (m: any) => !m.mrp || m.mrp <= 0
  //   );

  //   if (hasMissingMrp) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Missing Data',
  //       detail: 'Please enter MRP for all medicines before previewing the quotation.',
  //     });
  //     return; // 👈 stop here
  //   }

  //   const doc = this.createQuotationPdf();
  //   if (!doc) return;

  //   const pdfBlob = doc.output('blob');
  //   const pdfUrl = URL.createObjectURL(pdfBlob);
  //   this.quotationPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);

  //   this.dialog.open(this.quotationPreviewModal, {
  //     width: '80%',
  //     height: '80%'
  //   });
  // }



  // 🔹 Download as file
  downloadQuotation() {
    const doc = this.createQuotationPdf();
    doc.save('quotation.pdf');
  }
  // Block invalid keystrokes (real-time)
  // Prevent invalid typing
  validateMRPInput(event: KeyboardEvent) {
    const input = event.key;
    const value = (event.target as HTMLInputElement).value;

    // allow control keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(input)) return;

    // allow only digits + dot
    if (!/[0-9.]/.test(input)) {
      event.preventDefault();
      return;
    }

    const parts = value.split('.');

    // prevent more than 5 digits in integer part
    if (!value.includes('.') && parts[0].length >= 5 && input !== '.') {
      event.preventDefault();
      return;
    }

    // prevent more than 2 decimals
    if (value.includes('.') && parts[1]?.length >= 2) {
      event.preventDefault();
      return;
    }
  }

  // Clean pasted values
  sanitizeMRP(event: any, element: any) {
    let value = event.target.value;

    // keep only numbers and dot
    value = value.replace(/[^0-9.]/g, '');

    // allow only one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1];
    }

    // restrict integer part to 5 digits
    parts[0] = parts[0].slice(0, 5);

    // restrict decimal part to 2 digits
    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
    }

    value = parts.join('.');

    element.mrp = value;
    event.target.value = value;
  }

  limitMRP(event: any, element: any) {
    let value: string = event.target.value;

    // ✅ Allow only numbers and dot
    value = value.replace(/[^0-9.]/g, '');

    // ✅ Only one dot allowed
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1];
    }

    // ✅ Restrict integer part to 5 digits
    if (parts[0].length > 5) {
      parts[0] = parts[0].slice(0, 5);
    }

    // ✅ Restrict decimal part to 2 digits
    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
    }

    value = parts.join('.');

    // update model + input box
    element.mrp = value;
    event.target.value = value;
  }


  // totalQuotationAmount:any;

  updateCalculations(element?: any) {
    if (element) {
      let mrp = Number(element.mrp) || 0;

      // ✅ Allow up to 5 digits + 2 decimals (99999.99)
      if (mrp > 99999.99) {
        mrp = 99999.99;
        element.mrp = mrp.toFixed(2);
      }

      const baseAmount = mrp;

      element.sgst = +(baseAmount * 0.025).toFixed(2);
      element.cgst = +(baseAmount * 0.025).toFixed(2);
      element.totalAmount = +(baseAmount + element.sgst + element.cgst).toFixed(2);
    }
  }




  // medicineQuotationArr: any[] = [];

  getAppointmentsByPatientId() {
    const obj = {
      patientId: this.pramPatientId,
      isForHistory: true,
    };

    this.patientService.getAppointmentsByPatientId(obj).subscribe((response: any) => {
      console.log(" ", response);

      if (response.historyArr && response.historyArr.length > 0) {
        // ✅ get the last visit object
        const lastVisit = response.historyArr[response.historyArr.length - 1];
        console.log("Last Visit", lastVisit, response.historyArr);

        // ✅ Extract visit_date (only date part)
        const visitDateStr = lastVisit.Visit.updatedAt?.split("T")[0];
        const todayStr = new Date().toISOString().split("T")[0];
        console.log("visitDateStr", visitDateStr, todayStr);


        if (visitDateStr === todayStr) {
          // ✅ medicines from last visit
          this.lastVisitMed = lastVisit.Visit.Medicines || [];
          console.log("Last Visit Medicines", this.lastVisitMed);
        } else {
          this.lastVisitMed = [];
          this.messageService.add({
            severity: 'warn',
            summary: 'Missing Data',
            detail: 'For today\'s date Prescription is not created.',
          });
        }
      } else {
        this.lastVisitMed = [];
      }


      // ✅ Now check localStorage
      const localData = localStorage.getItem("medicineDataForQuate_" + this.pramPatientId);

      this.medicineQuotationArr = [...this.lastVisitMed];
      this.medicineQuotationArr.forEach((med: any) => {
        med.quantity = this.calculateQuantity(med);  // reference only
        med.packaging = med.quantity;                 // default same as quantity
      });
      console.log("medicineQuotationArr (from last visit)", this.medicineQuotationArr);

    });
  }

  calculateQuantity(med: any): number {
    let totalPerDay = 0;

    if (med.dosage2) {
      const parts = med.dosage2.split("-").map((p: any) => p.trim());

      for (let p of parts) {
        let num = parseFloat(p);

        // Fractions
        if (p.includes("½")) num = 0.5;
        if (p.includes("¼")) num = 0.25;
        if (p.includes("¾")) num = 0.75;

        if (!isNaN(num)) {
          totalPerDay += num;
        }
      }
    }

    // ✅ Default days = 1
    let days = 1;

    if (med.duration2) {
      const match = med.duration2.match(/\d+/);
      if (match) {
        let value = parseInt(match[0], 10);

        if (/day/i.test(med.duration2)) {
          days = value; // already in days
        } else if (/week/i.test(med.duration2)) {
          days = value * 7; // convert weeks → days
        } else if (/month/i.test(med.duration2)) {
          days = value * 30; // approx 30 days per month
        }
      }
    }

    // ✅ Final total quantity
    return +(totalPerDay * days).toFixed(2);
  }


  // Base quantity (dosage × days)
  // calculateQuantity(element: any): number {
  //   const dosage = Number(element.dosage) || 0;
  //   const days = Number(element.days) || 0;
  //   return dosage * days;
  // }

  // Final quantity (base × pack size)
  calculateFinalQuantity(element: any): number {
    const baseQty = this.calculateQuantity(element);
    const packaging = Number(element.packaging) || 1;
    return baseQty * packaging;
  }




  // Calculate base quantity from dosage × duration
  calculateBaseQuantity(element: any): number {
    const dosage = Number(element.dosage) || 0;
    const days = Number(element.days) || 0;
    return dosage * days;
  }

  // Called when user edits quantity manually
  updateQuantity(element: any) {
    // if doctor overrides, keep his value
    element.quantity = Number(element.quantity) || element.baseQuantity;

    // update totals if needed
    this.updateCalculations(element);
  }
  // When doctor edits pack size

  allowOnlyNumbers(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  onPackagingBlur(med: any) {
    if (!med.packaging || Number(med.packaging) < 1) {
      med.packaging = med.quantity; // fallback only after leaving the field
    } else {
      med.packaging = Number(med.packaging); // normalize
    }
  }


}